<template>
  <RevDrawer
    :name="MODAL_NAMES.SEE_MORE_AVERAGE_SELLING_PRICE"
    :title="i18n(translations.seeMoreAverageSellingPrice)"
  >
    <template #body>
      <div class="flex flex-col gap-12">
        <p>
          {{ i18n(translations.seeMoreAverageSellingPriceContent) }}
        </p>
        <ul class="list-inside list-disc">
          <li>
            <span class="body-1-bold mr-4">{{
              i18n(translations.seeMoreAverageSellingPriceContentItem1)
            }}</span
            ><span>{{
              i18n(translations.seeMoreAverageSellingPriceContentItem1Value)
            }}</span>
          </li>
          <li>
            <span class="body-1-bold mr-4">{{
              i18n(translations.seeMoreAverageSellingPriceContentItem2)
            }}</span
            ><span>{{
              i18n(translations.seeMoreAverageSellingPriceContentItem2Value)
            }}</span>
          </li>
        </ul>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/buyback/constants'

import translations from './ModalSeeMoreAverageSellingPrice.translations'

const i18n = useI18n()
</script>
